export class DepensesCarteSearch {
  constructor (depensesCarteSearch) {
    this.possibleCardsToSee = depensesCarteSearch ? depensesCarteSearch.possibleCardsToSee : null
    this.loggedUser = depensesCarteSearch ? depensesCarteSearch.loggedUser : null
  }
}
